<template>
  <div class="itemBox">
    <div class="checkBox">
        <el-checkbox v-model="item.checked" v-if="!item.hideCheckbox"></el-checkbox>
    </div>
    <div class="num">{{item.id}}</div>
    <div class="moduleType">{{item.moduleType}}</div>
    <div class="statusDesc">
        {{filterStatusDesc}}
    </div>
    <div class="operate" v-if="item.operate">操作</div>
    <div class="operate" v-if="showOperate">
      <div class="operate_btn">
        <el-button size="mini" type="primary" @click="showSource = true">分配资源</el-button>
      </div>
    </div>

    <set-source v-if="showSource" :visible="showSource"
     :deviceId="item.deviceId"
     :module="item.moduleType"
     :moduleVersion="item.moduleVersion"
     :hasServiceHelper="item.hasServiceHelper"
     :instanceId="item.id"
     :resourceId="item.resource.id"
     @sourceCallback="sourceCallback"/>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import SetSource from '../instance/SetSource.vue';
export default {
    name: 'ArrangeEditListItem',
    components: { SetSource },
    props: {
        item: {
            type: Object,
            required: true,
            default: {}
        },
        showOperate: {
            type: Boolean,
            default: true
        }
    },
    data: vm=>({
        showSource: false,
        isReset: '', //是否是重新分配资源

    }),
  mounted(){
  },
    computed: {
      filterStatusDesc() {
        if (this.item.statusDesc) {
          return this.item.statusDesc;
        }
        // if(this.item.status.description){
        //     return this.item.status.description
        // }
        let progressName = "";
        let valueDesc = "";
        switch (this.item.status.progress) {
          case 7:
            progressName = "创建";
            break;
          case 8:
            progressName = "建立依赖";
            break;
          case 9:
            progressName = "配置";
            break;
          case 0:
            progressName = "安装发送";
            break;
          case 1:
            progressName = "下载";
            break;
          case 2:
            progressName = "安装";
            break;
          case 3:
            progressName = "卸载";
            break;
          case 4:
            progressName = "启动";
            break;
          case 5:
            progressName = "停止";
            break;
          case 6:
            progressName = "心跳连接";
            break;
          case 10:
            progressName = "心跳中断";
            break;
          case 11:
            progressName = "启动发送";
            break;
          case 12:
            progressName = "停止发送";
            break;
          case 13:
            progressName = "心跳连接发送";
            break;
          case 14:
            progressName = "心跳中断发送";
            break;
          case 15:
            progressName = "卸载发送";
            break;
          case 16:
            progressName = "卸载备份";
            break;
          case 17:
            // 释放资源
            progressName = "释放资源";
            break;
          case 18:
            // 分配资源
            progressName = "分配资源";
            break;
          case 19:
            // 实例下载
            progressName = "实例下载";
            break;
          default:
            progressName = "创建";
        }

        switch (this.item.status.value) {
          case 0:
            valueDesc = "进行中";
            break;
          case 1:
            valueDesc = "成功";
            break;
          case 2:
            valueDesc = "失败";
            break;
        }

        return progressName + valueDesc;
      },
      status(){
        let progressName
        switch (this.item.status.progress) {
          case 7:
            progressName = "create";
            break;
          case 8:
            progressName = "depend";
            break;
          case 9:
            progressName = "deploy";
            break;
          case 0:
            progressName = "install_send";
            break;
          case 1:
            progressName = "download";
            break;
          case 2:
            progressName = "install";
            break;
          case 3:
            progressName = "uninstall";
            break;
          case 4:
            progressName = "start";
            break;
          case 5:
            progressName = "stop";
            break;
          case 6:
            progressName = "heartConnect";
            break;
          case 10:
            progressName = "heartBreak";
            break;
          case 11:
            progressName = "start_send";
            break;
          case 12:
            progressName = "stop_send";
            break;
          case 13:
            progressName = "heartConnect_send";
            break;
          case 14:
            progressName = "heartBreak_send";
            break;
          case 15:
            progressName = "uninstall_send";
            break;
          case 16:
            progressName = "uninstall_clone";
            break;
          case 17:
            // 释放资源
            progressName = "releaseResource";
            break;
          case 18:
            // 分配资源
            progressName = "setResource";
            break;
          case 19:
            // 实例下载
            progressName = "instancedownload";
            break;
          default:
            progressName = "create";
        }
        return progressName
      },
      value(){
        let val;
        switch (this.item.status.value){
          case 1:
            val = 'success';
            break;
          case 2:
            val = 'failed';
            break;
          case 0:
            val = 'running';
            break;
        }
        return val
      },
      // 释放资源
      showRelease(){
        let showFlag = false;
        // 分配资源
        if(this.item.status.operation.register == 1){
          showFlag = true
        }
        // 配置
        if(this.item.status.operation.allocate == 1){
          showFlag = false
        }
        // 卸载 优先级最高
        if(this.item.status.operation.uninstall == 1){
          showFlag = true
        }
        // 若正在执行安装操作，不能释放资源
        if(this.status == 'install' && this.value == 'running'){
          showFlag = false
        }
        return showFlag
      }
    },
    methods: {
      // 重配资源
      reSetResource(){
        if(this.item.status.operation.release != 1){
          this.isReset = true
        }else{
          this.isReset = false
        }

        this.showSource = true
      },
        // 分配资源回调
        sourceCallback(val){
          if(val != false){
                // 创建实例
                let model = {
                  content: val,
                  id: this.item.resource.id
                }

                this.$axios.post(this.baseUrl3 + "instance/register/resource", model)
                    .then(({ data: { msg, data, code } }) => {
                        if(code == 20000){
                            this.$message.success('操作成功')
                            this.showSource = false
                        }else{
                            this.$message({ showClose: true, message: msg, type: "error" });
                            console.log(msg);
                        }
                    }).catch(err => {
                      this.$message.error('操作失败')
                    });
          }else{
            this.showSource = false
          }
        },

    },
}
</script>
<style scoped>
.itemBox {
  padding: 12px 0;
  position: relative;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
}

.num,
.name,
.alias,
.checkBox,
.moduleVersion,
.deviceName,
.moduleType,
.statusDesc,
.operate,
.resultDesc {
  display: inline-block;
  text-align: center;
  vertical-align: middle;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
  line-height: 40px;
}

.checkBox{
    width: 5%;
    text-align: center;
}
.num {
  width: 10%;
  /* text-align: left; */
}
.moduleType {
  width: 20%;
}
.statusDesc{
    width: 35%;
}
.operate {
  width: 30%;
  display: inline-block;
  text-align: center;
  /* vertical-align: middle; */
  height: 100%;
}
</style>
